<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Search condition') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="seller_name"
                                       label="Seller name"
                                       size="3"
                                       :isFocus="true"
                                       v-model:field="search.seller_name" />

                        <FormInputText fieldName="code"
                                       label="Code"
                                       size="3"
                                       v-model:field="search.code" />

                        <FormInputText fieldName="address"
                                       label="Address"
                                       size="3"
                                       v-model:field="search.address" />

                        <FormInputToggleButton fieldName="is_active"
                                               label="Is active seller?"
                                               size="3"
                                               v-model:field="search.is_active" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>


        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from "@crud/FormInputText.vue";
import FormInputToggleButton from "@crud/FormInputToggleButton.vue";

import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

const options = ["sellers"];
const select = ref(null);

let search = ref({})

prepareSearch(search, props, options, select)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
